import React from 'react'
import parse from 'html-react-parser'

import Layout from '../components/layout'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import StudentsSplash from '../../static/img/students-splash.jpg'
import Graduate1X from '../../static/img/graduate.jpg'
import StudentsParallax from '../../static/img/students-parallax.jpg'

const styles = { height: 612, width: "100%" };
const IconStyles = {width:'90px',height:'90px',objectFit:'contain'};

function BlueButton(props){
  return <a href={props.link} className="btn btn-secondary pr-5 pl-5 pt-3 pb-3 rounded-0 ml-1 mr-2" target="_blank">{props.text}</a>
}

class StudentPage extends React.Component{
     constructor(props) {
          super(props);
     }
     render(){
       let content = this.props.data.studentsPageContent;
       let blueButtons = [];
       blueButtons = content.section2.buttons.map((item,key)=>
        <BlueButton key={key} {...item} />
       );
       let blueButtons3 = [];
       blueButtons3 = content.section3.buttons.map((item,key)=>
        <BlueButton key={key} {...item} />
       );
          return(
            <Layout className="students-page">

                 <div
                      className="splash jumbotron"
                      style={{minHeight:'400px',marginBottom:'0px', backgroundImage:`url(${StudentsSplash})`, backgroundSize:'cover', backgroundPosition: 'center center'}}
                    >

                    <h1 className="text-white text-center wow fadeInDown">{content.title}</h1>
               </div>

               <div className="container-fluid  container-students pt-4 pb-4">
                    <div className="container">
                         <div className="row">
                              <div className="col-lg-12 text-center">
                                   <h2 className="text-primary mt-4 wow fadeInDown">{content.section1.title}</h2>
                                   <p className="h2 mt-2 mb-4 text-light font-weight-light wow fadeInUp">{parse(content.section1.description)}</p>
                              </div>
                         </div>
                    </div>
               </div>

               <div className="container container-graduate pt-4 pb-4">
                    <div className="row">
                         <div className="col-lg-6">
                              <h2 className="text-primary mt-4">{parse(content.section2.title)}</h2>
                              <h3 className="text-primary">{parse(content.section2.subtitle)}</h3>
                              {parse(content.section2.description)}
                         </div>
                         <div className="col-lg-1"></div>
                         <div className="col-lg-5 wow fadeInRight">
                              <img src={content.section1.image[0].url} alt="Rice Graduation" />
                         </div>
                    </div>
                    <div className="row">
                         <p>
                            {blueButtons}
                         </p>
                    </div>

               </div>

               <div
               className="splash jumbotron"
               style={{minHeight:'281px',paddingTop:'0px',marginBottom:'0px',backgroundImage:`url(${StudentsParallax})`, backgroundSize:'cover', backgroundPosition: 'center center'}}>
                  <p>&nbsp;</p>
             </div>

             <div className="container container-graduate pt-4 pb-4">
                  <div className="row">
                       <div className="col-lg-12">
                            <h2 className="text-primary mt-4">{parse(content.section3.title)}</h2>
                       </div>
                  </div>
                  <div className="row">
                       <div className="col-md-12">
                            <h3 className="text-primary wow fadeInDown">{parse(content.section3.subtitle)}</h3>
                            {parse(content.section3.description)}
                            <p>
                              {blueButtons3}
                            </p>
                    </div>
               </div>
          </div>
            </Layout>
       );
  }
 }

export default StudentPage;
export const query = graphql`
query StudentsPage {
studentsPageContent: flamelinkStudentsPageContent{
    title,
    section1{
      title,
      description,
      image {
        url
      }
    },
    section2{
      title,
      subtitle,
      description,
      buttons{text,link}
    },
    section3{
      title,
      subtitle,
      description,
      buttons{text,link}
    }
  }
}`;
